
import React from "react";
import { indexTag } from "../../helpers";
import styles from "../../assets/style.module.css";
import { IHostManager } from "../../../../../services";

export interface ManagerCardProps {
    index: number;
    manager: IHostManager;
    onSelect: (m: IHostManager) => void;
}

function ManagerCard({ index, manager: m, onSelect }: ManagerCardProps) {
    return (<button className={styles["crew-card"]} onClick={() => onSelect(m)}>
        <span className={styles["tag"]}>{indexTag(index)}</span>
        <span className={styles["crew-img"]}>
            <img src={m.half_body_picture_url || m.passport_picture_url} alt={m.display_name} loading="lazy" />
        </span>
        <span className={styles["crew-text"]}>
            <span className={styles["crew-name"]}>{m.display_name}</span>
            <span className={styles["crew-role"]}>↳ {m.display_role ?? m.role}</span>
        </span>
    </button>);
}

export default ManagerCard;
